import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, PUT } from "../../services/api";


// Async Thunk: Fetch CMS Content (View)
export const getCMSData = createAsyncThunk(
  "cms/get",
  async (contentType, { rejectWithValue }) => {
    try {
      const response = await GET(`/tenant/cms/view?content_type=${contentType}`);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || "Failed to fetch CMS data");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);

// Async Thunk: Update CMS Content (PUT)
export const updateCMSData = createAsyncThunk(
  "cms/update",
  async ({ contentType, updatedContent }, { rejectWithValue }) => {
    try {
      const response = await PUT(`/tenant/cms?content_type=${contentType}`, {
        ...updatedContent,
      });

      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || "Failed to update CMS data");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);

const cmsManagementSlice = createSlice({
  name: "cmsManagement",
  initialState: {
    cmsData: null,
    cmsLoading: false,
    cmsError: null,
    updateLoading: false,
    updateError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // View CMS Data
      .addCase(getCMSData.pending, (state) => {
        state.cmsLoading = true;
        state.cmsError = null;
      })
      .addCase(getCMSData.fulfilled, (state, action) => {
        state.cmsLoading = false;
        state.cmsData = action.payload;
      })
      .addCase(getCMSData.rejected, (state, action) => {
        state.cmsLoading = false;
        state.cmsError = action.payload;
      })

      // Update CMS Data
      .addCase(updateCMSData.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
      })
      .addCase(updateCMSData.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.cmsData = action.payload; // Update state with new CMS content
      })
      .addCase(updateCMSData.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
      });
  },
});

export default cmsManagementSlice.reducer;
